import router from '../../router'
import {allowOnlyAuthorized} from '../../router/routeGuards'

import FrameView from './FrameView.vue'
// import oldFrameView from './oldProjectDetails.vue'
import AppHeader from '../../components/layout/Header'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/frame-view/:projectId/:videoId/:type',
      name: 'frame-view',
      components: {
        default: FrameView,
        header: AppHeader
      },
      meta: {
        dontShowInMenu: true,
        highlightProject: true,
      },
      beforeEnter: allowOnlyAuthorized(),
      scrollBehavior () {
        return { x: 0, y: 0 }
      }
    },
  ])
}
